// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow_arrow__QcCtG"};